
<div class="sm:min-w-[407.5px] sm:min-h-[225px] min-w-[300px] min-h-[225px]">
    <div class="hover-card  " 
        [ngClass]="isWebComponent || showCheckBox ? 'h-[245px] w-[347px]' : 'h-[210px] w-full '"
        [ngClass]="{
            'h-[295px]' : isWebComponent || showCheckBox,
            'w-[347px]' : isWebComponent,
            'h-[210px]' : !(isWebComponent || showCheckBox),
            'w-full' : !(isWebComponent)
        }">
        <div [ngClass]="isWebComponent ? '' : 'flex justify-center w-full'">
            <div (click)="isEditing ? null : onSelectCard(card!)" 
                [ngClass]="{
                    'selected' : (card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id) && isWebComponent,
                    'unselected' : !(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id),
                    'px-[42px]' : isWebComponent || showCheckBox,
                    'w-[347px]' : isWebComponent || showCheckBox,
                    'px-[30px]' : !(isWebComponent || showCheckBox),
                    'w-[338px]' : !(isWebComponent || showCheckBox)
                }"
                class=" rounded-xl m-2  py-[33px] h-[200px]  cc-gradient">
                <div class="flex flex-row justify-between">
                    <img src="/credit-cards/{{card?.creditCardInfo?.type}}.svg" class="h-[27px] w-[39px]">
                    <div *ngIf="card?.isDefaultCard" class="rounded-xl shadow-md  font-[DMSans] text-[18px] font-bold text-white">
                        <p-tag value="Default"  [style]="{ background: 'var(--dark-blue)'}" />
                    </div>
                </div>
                <div class=" text-white text-[30px] items-center font-[DMSans] font-bold mt-[43px] min-h-[45px] whitespace-nowrap">
                    <div *ngIf="!((card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id) && isEditing)">{{'**** **** **** '+card?.creditCardInfo?.lastDigits}}</div>
                    <div *ngIf="(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id) && isEditing">{{maskStringExceptLast(this.cardNumberFormValue)}}</div>
                </div>
                <div class="flex flex-row justify-between">
                    <div class="font-[DMSans] text-[20px] font-bold text-white">
                        <div *ngIf="(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id)" class="max-w-[200px] whitespace-nowrap overflow-hidden">{{this.cardHolderFormValue}}</div>
                        <div *ngIf="!(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id)" class="max-w-[200px] whitespace-nowrap overflow-hidden">{{card?.cardHolderName}}</div>
                    </div>
                    <div *ngIf="(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id)" class="font-[DMSans] text-[20px] font-bold text-white">{{this.monthFormValue + '/' + this.yearFormValue }}</div>
                    <div *ngIf="!(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id)" class="font-[DMSans] text-[20px] font-bold text-white">{{ (card?.expirationMonth | number:'2.0')}}{{ '/' + card?.expirationYear?.toString()?.substring(2) }}</div>
                </div>
            </div>
        </div>
        
        <div *ngIf="showCheckBox && !(isEditing && !(card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id))" class="justify-center w-full h-[35px] mt-[15px]" 
            [ngClass]="isAlwaysVisibleCheckBox || (card?.creditCardInfo?.id == selectedCard?.creditCardInfo?.id) || isEditing ? 'flex' :  'hidden'">
            <div class="w-[70px] h-[60px] p-[4px]  " (click)="onEditCard(card!)" [ngClass]="{'disable-click': isEditing}"
            [ngClass]="{'disable-click': isEditing}">
                <div class="flex justify-center">
                    <p-avatar styleClass="shadow-md"  size="normal" 
                     [ngClass]=" isEditing ? '!text-[var(--dark-blue)]' :  '!bg-white'">
                        <fa-icon class="text-white" *ngIf="isEditing" [icon]="faPenToSquare"></fa-icon>
                        <fa-icon class="!text-[var(--dark-blue)]" *ngIf="!isEditing" [icon]="faPenToSquare"></fa-icon>
                    </p-avatar>
                </div>
                <div class="flex justify-center  mt-[2px]  h-[18px]">
                    <span class="text-[14px] text-[var(--dark-blue)] font-bold">Edit</span>
                </div>
            </div>            
            <div class="w-[70px] h-[60px] p-[4px]" (click)="onChildCheckboxChange(card!)" 
            [ngClass]="{'disable-click': card!.isDefaultCard}">
                <div class="flex justify-center">
                        <p-avatar styleClass="shadow-md !bg-white"  size="normal" >
                            <fa-icon class="text-[var(--dark-blue)]" *ngIf="card!.isDefaultCard" [icon]="faSquareCheck"></fa-icon>
                            <fa-icon class="text-[var(--dark-blue)]" *ngIf="!card!.isDefaultCard" [icon]="faSquare"></fa-icon> 
                        </p-avatar>
                </div>
                <div class="flex justify-center  mt-[2px]  h-[18px]">
                    <span class="text-[14px] text-[var(--dark-blue)] font-bold">Default</span>
                </div>
            </div>
            <div class="w-[70px] h-[60px] p-[4px] " (click)="confirmDeleteFunc(card!)">
                <div class="flex justify-center">
                    <p-avatar styleClass="shadow-md !bg-white"  size="normal" >
                        <fa-icon class="text-[var(--dark-blue)]" [icon]="faTrashCan"></fa-icon>
                    </p-avatar>
                </div>
                <div class="flex justify-center mt-[2px] h-[18px]">
                    <span class="text-[14px] text-[var(--dark-blue)] font-bold">Remove</span>
                </div>
            </div>
        </div>
    </div>
</div>
